import request from '../utils/request'
import { common, index } from './url'
import { API_URL, API_URL_V2 } from '../config'
import { uploadFile } from '../utils/uploadFile'

const commonUrl = {
  kllist: API_URL + 'v1/list/data',
  feedback: API_URL_V2 + 'v2/user/feedback'
}
export const getSubjectList = () => request.get(common.base, { params: { type: 'subject' } })
export const getExamAreaList = () => request.get(common.base, { params: { type: 'examArea' } })
export const getArea = (pid) => request.get(common.area + pid)
export const getIndex = () => request.get(index)
export const getKlListApi = (params, config) => request.get(commonUrl.kllist, {params, ...config})
export const feedbackApi = (data, config) => uploadFile.post(commonUrl.feedback, data, config)
